import { type MutationOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import { type ReqDeleteVisaBulletinDataMutation } from './types'

export const deleteVisaBulletinDataMutation: MutationOptions<null, unknown, ReqDeleteVisaBulletinDataMutation> = {
  mutationFn: ({ caseId }) => w.delete(`${API_ENDPOINTS.business.v1['case-extra'].bulletin.index}/${caseId}`).json(),
}
